import get from 'lodash/get';
import * as authorPageActions from '../../action_creators/author/author_page_action_creators';
import authorAllFeedActions from './async_author_all_feed_actions';
import authorActions from './async_author_actions';
import asyncRecircFeedActions from '../async_recirc_feed_actions';
import notFoundActionCreator from '../../action_creators/not_found_status_action_creator';
import log from '../../../services/logger_service';

export default function fetchAuthorPage(params, store) {
  return function firstAuthorPageDispatch(dispatch) {
    dispatch(authorPageActions.authorPageLoading());
    return Promise.all([
      authorActions(params, store)(dispatch),
      authorAllFeedActions(params, store)(dispatch),
      asyncRecircFeedActions(params, store)(dispatch)
    ])
      .then(function handleAuthorPageData() {
        dispatch(authorPageActions.authorPageLoaded({}, store));
        return true;
      })
      .catch(function handleAuthorPageError(err) {
        const status = get(err, 'response.status') || 500;
        if (status === 404) {
          dispatch(notFoundActionCreator(404, 'NOT_FOUND_STATUS', store));
        } else {
          dispatch(notFoundActionCreator(500, 'ERROR_STATUS', store));
          log.error(
            err,
            `Error in author page actions, message: ${err.message}`
          );
        }
        dispatch(authorPageActions.authorPageLoadError(err, store));
      });
  };
}
